import { Box, BoxProps } from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';

export interface MainLayoutSidebarProps extends BoxProps {
  side: 'left' | 'right';
  width?: string | number;
  fixed?: boolean;
  children: ReactNode;
}

export const Sidebar = ({
  side: _side,
  width = 194,
  fixed = false,
  children,
  ...props
}: MainLayoutSidebarProps): ReactElement => {
  return (
    <Box width={width} height="100%" {...props}>
      <Box position={fixed ? 'fixed' : 'static'} height="100%" width={width}>
        {children}
      </Box>
    </Box>
  );
};
